import { createContext } from 'react';

const UserContext = createContext(); // holds all shops

export default UserContext;
